<template>
   <tbody class="tbody-res">
    <tr>
      <td>
        <select v-model="selectedOption"  class="text-selection">
          <option
            :value="option.value"
            :key="option.value"
            v-for="option in item.options"
          >{{ option.text }}
          </option>
        </select>
      </td>
      <td>
        <select v-model="selectedColor"  class="text-selection">
          <option
            :value="option.value"
            :key="option.value"
            v-for="option in item.color"
          >{{ option.text }}
          </option>
        </select>
      </td>
      <td>
        <b-input type="text" v-model="item.rate_center"/>
      </td>
      <td>
        <select v-model="selectedColorTier"  class="text-selection">
          <option
            :value="option.value"
            :key="option.value"
            v-for="option in item.tier"
          >{{ option.text }}
          </option>
        </select>
      </td>
      <td class="tel_number">
        <b-input type="text" v-model="item.telephone_number"  class="b-input-tel input-text-media-size "/>
        <b-input type="text" v-model="item.telephone_numberSec" class="b-input-tel input-text-media-size"/>
        <b-input type="text" v-model="item.telephone_numberThr" class="b-input-tel input-text-media-size"/>
      </td>
      <td>
        <b-input type="text" v-model="item.city" class="b-input-tel"/>
      </td>
      <td>
        <b-form-checkbox
          id="checkbox-1"
          v-model="item.wildcard"
          :checked="item.wildcard"
          name="wildcard"
        >
        </b-form-checkbox>
      </td>
      <td>
        <b-form-checkbox
          id="checkbox-2"
          v-model="item.sequential"
          :checked="item.sequential"
          name="sequential"
        >
        </b-form-checkbox>
      </td>
      <td>
        <b-form-checkbox
          id="checkbox-3"
          v-model="item.on_net_only"
          :checked="item.on_net_only"
          name="onNetOnly"
        >
        </b-form-checkbox>
      </td>
      <td>
        <b-form-checkbox
          id="checkbox-3"
          v-model="item.local"
          :checked="item.local"
          name="local"
        >
        </b-form-checkbox>
      </td>
      <td>
        <b-button @click="addRow"  v-if="item.id === 1" class="bg-gray">Add Row</b-button>
        <b-button @click="deleteRow(item.id)" v-if="item.id !== 1" class="bg-danger">Delete Row</b-button>
      </td>
      <td>
        <p class="result">{{ item.result }}</p>
      </td>
    </tr>
    </tbody>
</template>

<script>
export default {
  name: "ItemForm",
  props: {
    initialItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      item: this.initialItem,
      selectedOption: '',
      selectedColor: '',
      selectedColorTier: '',
      count: 2,
    }
  },
  methods: {
    addRow() {
       const row =  {
         id: Math.random(),
         options: [
           { value: 1, text: 'AR' },
           { value: 2, text: 'AM' },
           { value: 3, text: 'SG' },
           { value: 4, text: 'SN'},
           { value: 5, text: 'LG'}
         ],
         color: [
           { value: 1, text: '#0048BA' },
           { value: 2, text: '#B0BF1A' },
           { value: 3, text: '#7CB9E8' },
           { value: 4, text: '#C0E8D5'},
           { value: 5, text: '#B284BE'}
         ],
         rate_center: '',
         tier: [
           { value: 1, text: '#0048BA' },
           { value: 2, text: '#B0BF1A' },
           { value: 3, text: '#7CB9E8' },
           { value: 4, text: '#C0E8D5'},
           { value: 5, text: '#B284BE'}
         ],
         telephone_number: '',
         telephone_numberSec: '',
         telephone_numberThr: '',
         city: 1,
         wildcard: false,
         sequential: false,
         on_net_only: false,
         local: false,
         result:this.item.id+'/'+this.count
       }
       this.$emit('addNewRow', row)
      this.count++
    },
    deleteRow(id) {
      this.$emit('deleteRow', id)
    }
  }
}
</script>

<style scoped lang="scss">

@media  (max-width: 1605px) {
  /* For mobile phones: */.input-text-media-size {
  margin-top: 15px;
   }
}
  .text-selection {
    width: 100px;
    padding: 5px;
    margin-top: 10px;
  }
  .tbody-res {
    background: #c9c8c7;
    padding: 5px 5px
  }
  tr {
    border-spacing: 10px 0;
    td {
      padding-left: 10px;
      padding-bottom: 10px;
      input {
        margin-top: 10px;
      }
      .b-input-tel {
        max-width: 50px;
      }
      .result {
        color: #45a565;
      }
    }
    .tel_number {
      display: flex;
      .b-input-tel {
        max-width: 50px;
        margin-left: 3px;
      }
    }
  }
</style>
